/* eslint-disable import/prefer-default-export */
export const userQueryKeys = {
  approvalLevelDetails: (id: number) => [id, "approval-level-details"],
  approvalLevelCreateOptions: ["approval-level-create-options"],
  userPendingTasks: ["has-tasks-pending"],
  userRecentlyDelivered: ["recently-delivered"],
  userFilterPresets: ["user-filter-presets"],
  userTemplates: ["user-templates"],
  userRoles: ["user-roles"],
  supplierCompanySlugs: ["supplier-company-slugs"],
  userWidgets: ["user-widgets"],
  userSettings: ["user-settings"],
  userNotifications: ["user-notifications"],
  userSearchContacts: (filters: Record<string, unknown>) => ["user-contacts", "search", filters],
  preferredContact: (referenceNumber: string) => ["preferred-contact", referenceNumber],
  bookedGraph: ["booked-graph"],
  recentUpdates: ["recent-updates"],
  orderStatus: ["order-status"],
  quoteRequestStatus: ["quote-request-status"],
  shipmentStatus: ["shipment-status"],
  invoiceStatus: ["invoice-status"],
  taskWidget: ["task-widget"],
  bookmarkWidget: ["bookmark-widget"],
  paymentLocationDetails: (referenceNumber: string) => ["payment-location-details", referenceNumber],
  developerApiTokens: (filters: any) => ["developer-api-tokens", "list", filters],
  parcelAccounts: (filters: any) => ["parcel-accounts", "list", filters],
  parcelAccountDetails: (id: number) => ["parcel-account-details", id],
  providerDetails: (location: string, slug: string) => ["provider-details", location, slug],
  providerListing: (location: string, filters: any) => ["provider", "list", location, filters],
  parcelProviderListing: (location: string, filters: any) => ["parcel-provider", "list", location, filters],
  accountMappings: (filters: Record<string, unknown>) => ["account-mappings", "list", filters],
  accountMappingPaymentLocations: (filters: Record<string, unknown> = {}) => [
    "account-mappings",
    "payment-locations",
    filters,
  ],
  scheduledReports: ["scheduled-report-list"],
  scheduledReportOptions: ["scheduled-report-options"],
};
